module.exports = __webpack_public_path__ + "static/media/i6.07190939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i6.svg
// module id = 408
// module chunks = 12